import { render } from "./App.vue?vue&type=template&id=1718264e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1718264e&lang=css"

import exportComponent from "/home/gremmel/prog/nodejs/bgg-statistic/ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__